// Globale queryparameters van de documentviewer: ?doc=<id> (+ optioneel docq = zoekterm,
// docpage = startpagina) werken op ELKE route. De rest van de URL blijft ongemoeid.

export const DOC_PARAM = "doc";
export const DOC_Q_PARAM = "docq";
export const DOC_PAGE_PARAM = "docpage";

export function readDocParams(params) {
  const id = Number(params.get(DOC_PARAM)) || null;
  const q = params.get(DOC_Q_PARAM) || "";
  const page = Number(params.get(DOC_PAGE_PARAM)) || null;
  return { id, q, page };
}

// Nieuwe URLSearchParams met de viewer-parameters gezet (id) of verwijderd (id leeg).
export function withDocParams(params, id, { q, page } = {}) {
  const next = new URLSearchParams(params);
  [DOC_PARAM, DOC_Q_PARAM, DOC_PAGE_PARAM].forEach((k) => next.delete(k));
  if (id) {
    next.set(DOC_PARAM, String(id));
    if (q) next.set(DOC_Q_PARAM, q);
    if (page && Number(page) > 1) next.set(DOC_PAGE_PARAM, String(page));
  }
  return next;
}

// Vaste, deelbare link: altijd via de documentenpagina (vraagt een login met rol).
export function documentShareUrl(id, origin = typeof window !== "undefined" ? window.location.origin : "") {
  return `${origin}/bank-documents?${DOC_PARAM}=${id}`;
}
